
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SignupTerms from "./SignupTerms";
import SignupInfo from "./SignupInfo";
import SignupComplete from "./SignupComplete";
import CommonTitle from '../../../components/common-title/CommonTitle';

function Signup() {
  const [step, setStep] = useState(0); // 0: 약관동의, 1: 정보입력, 2: 가입완료
  const [stepData, setStepData] = useState({}); // Store data between steps
  const navigate = useNavigate();

  const handleStep0Next = (step0Data) => {
    setStepData(prev => ({ ...prev, ...step0Data }));
    setStep(1);
  };

  return (
    <div className="signup">
      <div className="container">
      <main className="signup-main-column">
      <CommonTitle heading="회원가입" />
      
        <div className="tabs">
          <div className={`tab${step === 0 ? " active" : ""}`}>약관동의</div>
          <div className={`tab${step === 1 ? " active" : ""}`}>정보입력</div>
          <div className={`tab${step === 2 ? " active" : ""}`}>가입완료</div>
        </div>
        {step === 0 && <SignupTerms onNext={handleStep0Next} />}
        {step === 1 && <SignupInfo onNext={() => setStep(2)} onBack={() => setStep(0)} stepData={stepData} />}
        {step === 2 && <SignupComplete onLogin={() => navigate('/login')} />}
      </main>
      </div>
    </div>
  );
}

export default Signup; 